import React from 'react'
import "../../stylings/topper.css"
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { Autoplay, Pagination } from 'swiper/modules'

import firstClass  from '../../assest/topper photos/pratyusha.jpeg'
import secondClass from '../../assest/topper photos/devesh.jpeg'
import thirdClass  from '../../assest/topper photos/chirag.jpeg'
import fourthClass from '../../assest/topper photos/ishika.jpeg'
import fifthClass  from '../../assest/topper photos/pahal.jpeg'
import sixthClass  from '../../assest/topper photos/navneet.jpeg'
import sevenClass  from '../../assest/topper photos/harshit.jpeg'
import eightClass  from '../../assest/topper photos/prachi.jpeg'

const toppers = [
  { name: 'Pratyusha',     cls: '1st',  img: firstClass  },
  { name: 'Devesh Dabas',  cls: '2nd',  img: secondClass },
  { name: 'Chirag',        cls: '3rd',  img: thirdClass  },
  { name: 'Ishika Dabas',  cls: '4th',  img: fourthClass },
  { name: 'Pahal',         cls: '5th',  img: fifthClass  },
  { name: 'Navneet Verma', cls: '6th',  img: sixthClass  },
  { name: 'Harshit',       cls: '7th',  img: sevenClass  },
  { name: 'Prachi Singh',  cls: '8th',  img: eightClass  },
]

// rank colours for first three cards
const rankMeta = [
  { label: '🥇 1st', color: '#f5a623' },
  { label: '🥈 2nd', color: '#94a3b8' },
  { label: '🥉 3rd', color: '#cd7f32' },
]

const Topper = () => {
  return (
    <section className="tp-section">
      <div className="container">

        {/* ── Header ── */}
        <div className="tp-header">
          <div className="tp-header-left">
            <div className="tp-tag">
              <i className="fa-solid fa-trophy"></i>
              Academic Excellence
            </div>
            <h2 className="tp-title">Our Star Performers <span>2024–25</span></h2>
            <p className="tp-subtitle">
              Celebrating the brilliant students who topped their class this academic year with outstanding dedication and hard work.
            </p>
          </div>
          <div className="tp-badge">
            <i className="fa-solid fa-medal"></i>
            <div>
              <strong>8 Classes</strong>
              <span>Top Rankers Honoured</span>
            </div>
          </div>
        </div>

        {/* ── Swiper ── */}
        <Swiper
          slidesPerView={1}
          spaceBetween={16}
          autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          pagination={{ clickable: true, dynamicBullets: true }}
          breakpoints={{
            480:  { slidesPerView: 2, spaceBetween: 16 },
            768:  { slidesPerView: 3, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 22 },
            1280: { slidesPerView: 5, spaceBetween: 22 },
          }}
          modules={[Autoplay, Pagination]}
          className="tp-swiper"
        >
          {toppers.map((t, i) => (
            <SwiperSlide key={i}>
              <div className={`tp-card${i < 3 ? ' tp-card--ranked' : ''}`}>

                {/* rank badge */}
                {i < 3 && (
                  <div className="tp-rank-badge" style={{ '--rank-color': rankMeta[i].color }}>
                    {rankMeta[i].label}
                  </div>
                )}

                {/* photo */}
                <div className="tp-photo-wrap">
                  <img src={t.img} alt={t.name} className="tp-photo" />
                  {/* glow ring for top 3 */}
                  {i < 3 && <div className="tp-photo-ring" style={{ '--ring-color': rankMeta[i].color }}></div>}
                </div>

                {/* info */}
                <div className="tp-info">
                  <div className="tp-class-chip">Class {t.cls}</div>
                  <h4 className="tp-name">{t.name}</h4>
                  <div className="tp-stars">
                    {[...Array(5)].map((_, s) => (
                      <i key={s} className="fa-solid fa-star"></i>
                    ))}
                  </div>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  )
}

export default Topper
